<template>
  <v-dialog v-model="show" width="80%">
    <v-card>
      <v-card-title>
        <span class="headline">EIAJ検収伝票</span>
      </v-card-title>

      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex>EIAJ検収伝票総数：{{ number }}</v-flex>
          </v-layout>
        </v-container>
      </v-form>
      <v-card-actions>
        <v-btn @click="download" class="ml-2 mr-2">EIAJ検収伝票</v-btn>
        <v-btn @click="segmentationDownload" class="ml-2 mr-2"
          >EIAJ検収伝票（分割出力）</v-btn
        >伝票数が多い時、このボタンで出力ください、複数ファイルに分割し出力できます。
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    show: false,
    radioGroup: '',
    query: {},
    number: 0,
    id: null,
    errors: {
      NO_EIAJ: '無償の為ＥＩＡＪ検収伝票は出力されません。',
      UNPAID_HAS_NO_EIAJ:
        '無償の場合、EIAJ検収伝票は出力されないため、純無償請求書の画面から伝票を発行してください。',
    },
  }),
  methods: {
    popup(id) {
      console.log(id)
      this.$http
        .get(`/delivery-orders/${id}/get-eiaj-count`)
        .then((res) => {
          this.show = true
          this.id = id
          this.number = res.data
        })
        .catch((err) => {
          this.$showError(err)
        })
    },
    download() {
      this.$http.post(`/eiaj-history/${this.id}`).then(() => {
        this.$emit('load')
      })
      return this.$download(`/delivery-orders/${this.id}/batch-eiajs.pdf`)
    },
    segmentationDownload() {
      this.$http.post(`/eiaj-history/${this.id}`).then(() => {
        this.$emit('load')
      })
      var max = Math.ceil(this.number / 50)
      for (var i = 0; i < max; i++) {
        if (i === max - 1) {
          this.$download(
            `/delivery-orders/${this.id}/batch-eiajs.pdf?start=${i * 50}&end=${
              this.number
            }`
          )
        } else {
          this.$download(
            `/delivery-orders/${this.id}/batch-eiajs.pdf?start=${i *
              50}&end=${i * 50 + 50}`
          )
        }
      }
    },
  },
}
</script>
